// extracted by mini-css-extract-plugin
export default {"DocumentReview":"review-upload-page_DocumentReview__+KvwR"};